import React, { Fragment, useState, useEffect, useRef, useCallback, useMemo } from 'react';
import { IMAGES } from '../../../constants';
import { useSelector, useDispatch } from 'react-redux';
import Avatar from 'react-avatar';
import { useLocation } from 'react-router-dom';

import {
    convertLocaleTime,
    convertLocaleDate,
    scrollToBottomChat,
    scrollToBottomChatNew,
    convertLocaleMomentDate,
    encryptData,
    decryptData
} from '../../../helper';
import Welcome from './Welcome';
import $ from 'jquery';
import { socket } from '../../../utils/socket';
import { useAlert } from 'react-alert';
import { FormattedMessage, useIntl } from 'react-intl';
import LightGallery from 'lightgallery/react';
import lgZoom from 'lightgallery/plugins/zoom';
import lgVideo from 'lightgallery/plugins/video';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import validator from 'validator';
import { url, IMAGE_BASE_URL } from '../../../config';
import {
    getChatUserAction,
    getMessageHistoryAction,
    getshortMsg
} from '../../../actions/chatAction';
import Loader from '../../layout/Loader';
import ChatLoader from '../../layout/ChatLoader';

// ============================================================================
// CUSTOM HOOKS FOR BETTER SEPARATION OF CONCERNS
// ============================================================================

const useUserSession = () => {
    const userSession = JSON.parse(sessionStorage.getItem('user') || '{}');
    return {
        user_id: userSession?.id,
        user_name: userSession?.name,
        profile_picture_full_thumb: userSession?.profile_picture_full_thumb
    };
};

const useChatSession = () => {
    return {
        other_user_id: sessionStorage.getItem('other_user_id'),
        conversationId: sessionStorage.getItem('socket_group_id'),
        other_user_name: sessionStorage.getItem('other_user_name'),
        other_profile_picture_full_thumb: sessionStorage.getItem('other_profile_picture_full_thumb')
    };
};

const useSocketConnection = () => {
    useEffect(() => {
        const interval = setInterval(() => {
            if (socket) {
                socket.connected = true;
            }
        }, 3000);

        return () => clearInterval(interval);
    }, []);
};


const processText = (text) => {
    const urlPattern = /(https?:\/\/[^\s]+|www\.[^\s]+)/g;
    const parts = text.split(urlPattern).map((part, index) => {
        if (urlPattern.test(part)) {
            return (
                <a
                    key={index}
                    href={part.startsWith('www') ? `http://${part}` : part}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    {part}
                </a>
            );
        }
        return part;
    });
    return parts;
};

const escapeHtml = (value) => {
    if (value === null || value === undefined) return '';
    return String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
};

const isJson = (str) => {
    try {
        JSON.parse(str);
        return true;
    } catch (e) {
        return false;
    }
};

// ============================================================================
// MEMOIZED COMPONENTS FOR BETTER PERFORMANCE
// ============================================================================

const MessageStatusIcon = React.memo(({ isRead, isDelivered }) => {
    if (isRead == 1) {
        return <i className="fa-solid fa-check-double text-right font-14 class-blue"></i>;
    } else if (isRead == 0 && isDelivered == 0) {
        return <i className="fa fa-check text-right font-14" aria-hidden="true"></i>;
    } else if (isRead == 0 && isDelivered == 1) {
        return <i className="fa-solid fa-check-double d-block text-right font-14"></i>;
    }
    return null;
});

const MessageAttachment = React.memo(({ attachment, messageType, onClick }) => {
    if (!attachment?.image_url) return null;

    const renderAttachment = () => {
        switch (messageType) {
            case 'image':
                return (
                    <LightGallery plugins={[lgThumbnail, lgZoom, lgVideo]} mode="lg-fade" download={false}>
                        <img
                            src={IMAGE_BASE_URL + attachment.image_url}
                            alt="Product Image"
                            style={{ borderRadius: "10px 0 10px 10px" }}
                            width={60}
                            height={60}
                            onClick={onClick}
                        />
                    </LightGallery>
                );
            case 'video':
                return (
                    <video width="320" height="240" controls>
                        <source src={IMAGE_BASE_URL + attachment.image_url} type="video/mp4" />
                        <source src={IMAGE_BASE_URL + attachment.image_url} type="video/ogg" />
                        Your browser does not support the video tag.
                    </video>
                );
            case 'pdf':
                return (
                    <a href={IMAGE_BASE_URL + attachment.image_url} target="_blank">
                        <i className="fa fa-file-pdf-o" style={{ fontSize: '48px', color: 'red' }}></i>
                    </a>
                );
            default:
                return null;
        }
    };

    return (
        <div className="s-i-image">
            {renderAttachment()}
            {attachment.file_content && <p>{processText(attachment.file_content)}</p>}
        </div>
    );
});

const MessageItem = React.memo(({
    messageData,
    user_id,
    handleImage,
    isOwnMessage
}) => {
    const attachment = useMemo(() => {
        let att = messageData?.attachment_url;
        if (isJson(att)) {
            att = JSON.parse(att);
        }
        return att;
    }, [messageData?.attachment_url]);

    console.log('isOwnMessage>>>>', isOwnMessage);
    

    const messageClass = isOwnMessage ? 'u-messgae' : 'ownCmnt';
    const hasAttachment = messageData?.attachment_url && messageData?.attachment_url !== 'null';

    const handleProductClick = useCallback(() => {
        if (attachment?.product_url) {
            window.location.href = url + "/details/" + attachment.product_url;
        }
    }, [attachment?.product_url]);



    return (
        <div className={`d-flex my-4 align-content-end ${messageClass} mesgs ${hasAttachment ? 'NewChatLink' : ''}`}>
            <div>
                <div
                    className="d-flex align-items-center txts"
                    onClick={handleProductClick}
                    style={{ cursor: attachment?.product_url ? 'pointer' : 'default' }}
                >
                    {attachment?.image_url && (
                        <div className="s-i-image" onClick={() => attachment?.product_url ? window.location.href = url + "/details/" + attachment?.product_url : {}}>
                            {messageData?.message_type == 'image' && (
                                <><LightGallery plugins={[lgThumbnail, lgZoom, lgVideo]} mode="lg-fade" download={false}>
                                    <img src={attachment?.image_url ? IMAGE_BASE_URL + attachment?.image_url : attachment} alt="Product Image" style={{ borderRadius: "10px 0 10px 10px", }} width={60} height={60} onClick={() => { handleImage(attachment?.image_url ? attachment?.image_url : attachment, "image"); }} />

                                </LightGallery><p>{processText(attachment?.file_content ? attachment?.file_content : attachment)}</p>
                                </>

                            )}
                            {messageData?.message_type == 'video' && (
                                <><video width="320" height="240" controls>
                                    <source src={attachment?.image_url ? IMAGE_BASE_URL + attachment?.image_url : attachment} type="video/mp4" style={{ borderRadius: "10px 0 10px 10px", }} width={60} height={60}></source>
                                    <source src={attachment?.image_url ? attachment?.image_url : attachment} type="video/ogg" style={{ borderRadius: "10px 0 10px 10px", }} width={60} height={60}></source>

                                    Your browser does not support the video tag.

                                </video><p>{processText(attachment?.file_content ? attachment?.file_content : attachment)}</p></>

                            )}
                            {messageData?.message_type == 'pdf' && (
                                <a href={attachment?.image_url ? IMAGE_BASE_URL + attachment?.image_url : attachment} target="_blank">
                                    <i className="fa fa-file-pdf-o" style={{ fontSize: '48px', color: 'red' }}></i>
                                </a>

                            )}

                        </div>
                    )}

                    <div className="chatlinktext">
                        {(messageData?.message_type == 'text' || messageData?.message_type == 'TEXT') ?
                            <>
                                <div className="d-flex s-i-image">
                                    {
                                        attachment?.image_url &&
                                        <LightGallery plugins={[lgThumbnail, lgZoom, lgVideo]} mode="lg-fade" download={false}  >
                                            <img src={attachment?.image_url ? IMAGE_BASE_URL + attachment?.image_url : ""} alt="Product Image" style={{ borderRadius: "10px 0 10px 10px" }} width={60} height={60} onClick={() => { handleImage(messageData?.attachment_url, 'image') }} />
                                        </LightGallery>
                                    }
                                    {attachment?.product_url ? <a href={url + "/details/" + attachment?.product_url}>{processText(messageData.message)}</a> : <p> {processText(messageData.message)}</p>}
                                </div>

                            </>
                            :
                            <div>
                                {messageData?.message_type == "ENQUIRY" || messageData?.message_type == null ?
                                    <a
                                        className="d-flex align-items-center txts"
                                        // onClick={() => messageData?.product_id ? window.location.href = url + "/details/diamonds/" + messageData?.product_id : {}}
                                        href={url + "/details/diamonds/" + messageData?.product_id}
                                        style={{ cursor: 'pointer' }}
                                        target='_blank'
                                    >
                                        {

                                            attachment?.image_url &&
                                            <div className="s-i-image">
                                                <LightGallery
                                                    plugins={[lgThumbnail, lgZoom, lgVideo]}
                                                    mode="lg-fade"
                                                    download={false}
                                                >
                                                    <img
                                                        src={attachment?.image_url ? IMAGE_BASE_URL + attachment?.image_url : attachment}
                                                        alt="Product Image"
                                                        style={{ borderRadius: "10px 0 10px 10px" }}
                                                        width={60} height={60}
                                                        onClick={() => { handleImage(messageData?.attachment_url, 'image') }} />
                                                </LightGallery>
                                            </div>
                                        }
                                        <div className="chatlinktext">
                                            <p>{processText(messageData?.message)}</p>
                                        </div>
                                    </a>
                                    : null}
                            </div>

                        }
                    </div>
                </div>
                <div className="d-flex dats">
                    <p>
                        {convertLocaleMomentDate(messageData?.created_at)}
                        {isOwnMessage && (
                            <MessageStatusIcon
                                isRead={messageData?.is_read}
                                isDelivered={messageData?.is_delivered}
                            />
                        )}
                    </p>
                </div>
            </div>
        </div>
    );
});

// ============================================================================
// MAIN CHATBOX COMPONENT
// ============================================================================

const Chatbox = (props) => {
    const alert = useAlert();
    const dispatch = useDispatch();
    const location = useLocation();
    const messageContainerRef = useRef(null);
    const enquirySentRef = useRef(false);

    // Custom hooks
    const { user_id, user_name, profile_picture_full_thumb } = useUserSession();
    const { other_user_id, conversationId, other_user_name, other_profile_picture_full_thumb } = useChatSession();

    // State management
    const [message, setMessage] = useState('');
    const [chatData, setChatData] = useState([]);
    const [hash, setHash] = useState('0');
    const [isMsgRead, setIsMsgRead] = useState(false);
    const [page, setPage] = useState(1);
    const [limit] = useState(10);
    const [productDetailsStatus, setProductDetailsStatus] = useState(false);

    // Redux selectors
    const { messageHistory, loading } = useSelector(state => state.messageHistory);
    const { shortmsg } = useSelector(state => state.shortmsg);
    const { active_status } = useSelector(state => state.ChatActiveState);

    // Socket connection management
    useSocketConnection();

    useEffect(() => {
        dispatch(getshortMsg());
    }, [dispatch]);

    useEffect(() => {
    if (messageHistory && sessionStorage.getItem('newChat') === '0') {
        if (messageContainerRef.current) {
            messageContainerRef.current.innerHTML = '';
        }
        setHash('0');
        setPage(1);
        setChatData([]);
        setMessage('');
        sessionStorage.removeItem('newChat'); // Move this earlier to avoid redundant checks
        setTimeout(() => {
            setHash('1');
            scrollToBottomChatNew(messageContainerRef); // Call scroll after state reset
        }, 100);
    }
    if (messageHistory?.data?.length > 0) {
        if (sessionStorage.getItem('newChat') === '0') {
            setChatData(messageHistory?.data);
            setTimeout(() => {
                scrollToBottomChatNew(messageContainerRef); // Call scroll after messages are set
            }, 0);
        } else {
            setChatData(prev => [...prev, ...messageHistory?.data]);
            setTimeout(() => {
                // scrollToBottomChatNew(messageContainerRef); // Call scroll after appending messages
            }, 0);
        }
    } else {
        if (sessionStorage.getItem('newChat') === '0') {
            setChatData([]);
            setTimeout(() => {
                scrollToBottomChatNew(messageContainerRef); // Call scroll for empty chat
            }, 0);
        }
    }
}, [messageHistory]);

    // Socket event handlers
    useEffect(() => {

        const handleDeliverListener = (res) => {
            // const read_res = decryptData(res);
            const read_res = res;
            if (read_res?.status && read_res?.data?.other_user_id && user_id != read_res?.data?.other_user_id) {
                read_res?.data?.id?.forEach((data) => {
                    $(`#message${data}`).removeClass('fa-check').addClass('fa-solid fa-check-double');
                });
            }
        };

        const handleReadMessage = (res) => {
            // const read_res = decryptData(res);
            const read_res = res;
            if (read_res?.status) {
                setIsMsgRead(true);
                if (read_res?.data?.new_ids?.length) {
                    read_res?.data?.new_ids?.forEach((data) => {
                        if (Number(user_id) == Number(read_res?.data?.other_user_id)) {
                            $(`#message${data}`).removeClass('fa-check').addClass('fa-solid fa-check-double class-blue');
                        }
                    });
                }
            }
        };

        const handleReceiveMessage = (res) => {
            // setProductDetailsStatus(false);
            // console.log("handleReceiveMessage", res);
            // const new_res = decryptData(res);
            const new_res = res;

            if (user_id == new_res?.other_user_id) {
                dispatch(getChatUserAction());
            }

            if (conversationId && (conversationId != new_res?.group_id || !location?.pathname?.includes('message'))) {
                return;
            }
            if (other_user_id == new_res?.user_id && location?.pathname?.includes('message')) {
                const read = {
                    other_user_id: new_res?.user_id,
                    ids: [new_res?.id],
                    type: "msg_read"
                };
                // socket.emit('read_message', encryptData(read));
                socket.emit('read_message', read);
                dispatch(getChatUserAction());
            }
           console.log("appendMessageToDOM", new_res);
            
            appendMessageToDOM(new_res);
            scrollToBottomChat();
        };

        // Socket event listeners
        socket?.off('is_deliver_listener')?.on('is_deliver_listener', handleDeliverListener);
        socket?.off('receive_read_message')?.on('receive_read_message', handleReadMessage);
        socket?.off('receive_message')?.on('receive_message', handleReceiveMessage);

        return () => {
            socket?.off('is_deliver_listener', handleDeliverListener);
            socket?.off('receive_read_message', handleReadMessage);
            socket?.off('receive_message', handleReceiveMessage);
        };
    }, [user_id, other_user_id, conversationId, location?.pathname, dispatch]);

    // Product details effect
    // useEffect(() => {
    //     const productDetails = JSON.parse(sessionStorage.getItem('productDetails'));
    //     setTimeout(() => {
    //         if (productDetails) {
    //             const attachment = {
    //                 product_url: productDetails?.slug + '/' + productDetails?.id,
    //                 image_url: productDetails?.image
    //             };
    //             const { carat, certificate, clarity, color, shape, seller_id, stockNumber, cut, polish, symmetry, fluorescence } = productDetails;
    //             const message = `${shape} ${carat}ct  ${color ? color : ''} ${clarity ? clarity : ''} ${certificate ? certificate : ''} ${cut ? cut : ''} ${polish ? polish : ''} ${symmetry ? symmetry : ''} ${fluorescence ? fluorescence : ''} ${stockNumber ? stockNumber : ''}`;

    //             const data = {
    //                 product_id: productDetails?.id,
    //                 slug: productDetails?.slug,
    //                 other_user_id: seller_id,
    //                 message: message,
    //                 attachment_url: JSON.stringify(attachment),
    //                 type: 'ENQUIRY'
    //             };
    //             // socket.emit('send_message', encryptData(data));
    //             socket.emit('send_message', data);
    //             // socket?.emit('total_message_count', encryptData({ user_id: other_user_id }));
    //             socket?.emit('total_message_count', { user_id: other_user_id });
    //             socket.emit('total_message_count', {});
    //             setProductDetailsStatus(true);
    //             scrollToBottomChat();
    //         }
    //     }, 2000);
    // }, []);

    // useEffect(() => {
    //     if (socket?.connected) {
    //         window.onload = () => {
    //             setTimeout(() => {
    //                 sessionStorage.removeItem('productDetails');
    //             }, 2500);
    //         };
    //     }
    // }, [socket?.connected]);

    useEffect(() => {
        if (!socket?.connected) return;

        const params = new URLSearchParams(window.location.search);
        const chatId = params.get('chat');

        if (!chatId) {
            sessionStorage.removeItem('productDetails');
        }
    }, [socket?.connected]);


    const appendMessageToDOM = useCallback((new_res) => {
        const imageee = (user_id === new_res?.user_id)
            ? (profile_picture_full_thumb || IMAGES.IMAGE_01)
            : (new_res?.other_profile_pic || IMAGES.IMAGE_01);

        const alignClass = (user_id === new_res?.user_id) ? 'u-messgae' : 'ownCmnt';

        const statusIcon = (new_res?.is_read === 1 || isMsgRead)
            ? `<i class="fa-solid fa-check-double text-right font-14 class-blue" id="message${new_res.id}"></i>`
            : new_res?.is_read === 0 && new_res?.is_delivered === 0
                ? `<i class="fa fa-check text-right font-14" aria-hidden="true" id="message${new_res.id}"></i>`
                : new_res?.is_read === 0 && new_res?.is_delivered === 1
                    ? `<i class="fa-solid fa-check-double text-right font-14" id="message${new_res.id}"></i>`
                    : '';

        let varhtml = '';
        if (new_res?.message_type === 'TEXT') {
            const safeMessage = escapeHtml(new_res.message);
            const messageContent = validator.isURL(String(new_res.message ?? ''))
                ? `<a href="${safeMessage}" target="_blank" rel="noopener noreferrer"><p>${safeMessage}</p></a>`
                : `<p>${safeMessage}</p>`;

            varhtml = `<div class="d-flex my-4 align-content-end ${alignClass} mesgs">
                <div class="d-flex imgs"></div>
                <div class="m_t">
                    <div class="txts">${messageContent}</div>
                    <div class="d-flex dats">
                        <p>${convertLocaleMomentDate(Date.now())} ${alignClass === 'u-messgae' ? statusIcon : ""}</p>
                    </div>
                </div>
            </div>`;
        } else if (new_res?.message_type === 'image') {
            const imgObj = JSON.parse(new_res.attachment_url);
            varhtml = `<div class="d-flex my-4 align-content-end ownCmnt mesgs ${alignClass} mesgs">
                <div class="d-flex align-items-center txts">
                    <div class="s-i-image">
                        <img src="${IMAGE_BASE_URL}${escapeHtml(imgObj.image_url)}" style="border-radius: 10px 0 10px 10px;" width="60" height="60" />
                    </div>
                    <div class="d-flex dats">
                        <p>${escapeHtml(imgObj.file_content)}</p>
                        <p>${convertLocaleMomentDate(Date.now())} ${statusIcon}</p>
                    </div>
                </div>
            </div>`;
        }
        else if (new_res?.message_type === 'ENQUIRY') {
            const imgObj = JSON.parse(new_res.attachment_url);
            console.log('ownCmnt>>>', alignClass );
            
            varhtml = `
            <div class="d-flex my-4 align-content-end ${alignClass} mesgs NewChatLink">
            <div>
            <div class="d-flex align-items-center txts">
    <div class="s-i-image"></div>
    <div class="chatlinktext">
        <div>
            <a class="d-flex align-items-center txts" href="/details/diamonds/${escapeHtml(new_res?.product_id)}" target="_blank">
                <div class="s-i-image">
                    <div class="lg-react-element ">
                        <img src="${IMAGE_BASE_URL}${escapeHtml(imgObj.image_url)}" alt="Product Image" width="60" height="60" style="border-radius: 10px 0px 10px 10px;" data-lg-id="93e751f1-0dd7-4510-8f6a-549ed41eaa0e">
                    </div>
                </div>
                <div class="chatlinktext"><p>${escapeHtml(new_res.message)}</p></div>
            </a>
        </div>
    </div>
</div>
<div class="d-flex dats"><p>
${convertLocaleMomentDate(Date.now())} 
 ${alignClass === 'u-messgae' ? statusIcon : ""}</p></div>
</div></div>`;
        }

        // Check for duplicate messages
        const socketCreatedAt = sessionStorage.getItem('socket_created_at');
        const socketGroupId = sessionStorage.getItem('socket_group_id');
        const socketMessage = sessionStorage.getItem('socket_message');

        if (!socketCreatedAt && !socketGroupId && !socketMessage) {
            $(".message_list").append(varhtml);
            sessionStorage.setItem('socket_created_at', new_res?.created_at);
            sessionStorage.setItem('socket_group_id', new_res?.group_id);
            sessionStorage.setItem('socket_message', new_res?.message);
            sessionStorage.setItem('socket_flag', 1);
        } else if (socketCreatedAt === new_res?.created_at &&
            socketGroupId === new_res?.group_id &&
            socketMessage === new_res?.message) {
            return;
        } else {
            $(".message_list").append(varhtml);
            sessionStorage.setItem('socket_created_at', new_res?.created_at);
            sessionStorage.setItem('socket_group_id', new_res?.group_id);
            sessionStorage.setItem('socket_message', new_res?.message);
            sessionStorage.setItem('socket_flag', 1);
        }
    }, [user_id, profile_picture_full_thumb, isMsgRead]);

    const handleSendMessage = useCallback(() => {
        setIsMsgRead(false);
        if (!message || message.trim().length <= 0) {
            alert.error('Message is required');
            return;
        }

        if (socket?.connected === false) {
            socket.connected = true;
        }



        const productDetails = JSON.parse(sessionStorage.getItem('productDetails'));
           
            
            if (productDetails && !enquirySentRef.current && other_user_id == productDetails?.seller_id) {
                 console.log('productDetails other_user_id', other_user_id, 'productDetails seller_id', productDetails?.seller_id );
                //  setTimeout(() => {   
                enquirySentRef.current = true;
                const attachment = {
                    product_url: productDetails?.slug + '/' + productDetails?.id,
                    image_url: productDetails?.image
                };
                const { carat, certificate, clarity, color, shape, seller_id, stockNumber, cut, polish, symmetry, fluorescence } = productDetails;
                const message = `${shape} ${carat}ct  ${color ? color : ''} ${clarity ? clarity : ''} ${certificate ? certificate : ''} ${cut ? cut : ''} ${polish ? polish : ''} ${symmetry ? symmetry : ''} ${fluorescence ? fluorescence : ''} ${stockNumber ? stockNumber : ''}`;
                
                const enquiryData = {
                    product_id: productDetails?.id,
                    slug: productDetails?.slug,
                    other_user_id: seller_id,
                    message: message,
                    attachment_url: JSON.stringify(attachment),
                    type: 'ENQUIRY'
                };
                console.log('product details enq', enquiryData);
                
                // socket.emit('send_message', encryptData(data));
                socket.emit('send_message', enquiryData);
                // socket?.emit('total_message_count', encryptData({ user_id: other_user_id }));
                socket?.emit('total_message_count', { user_id: other_user_id });
                socket.emit('total_message_count', {});
                sessionStorage.removeItem('productDetails');
                setProductDetailsStatus(true);
                // scrollToBottomChat();
                // }, 700);
            }

        const data = {
            other_user_id: other_user_id,
            message: message,
            type: 'TEXT'
        };

        // socket?.emit('send_message', encryptData(data));
        socket?.emit('send_message', data);
        setMessage('');
        // socket?.emit('total_message_count', encryptData({ user_id: other_user_id }));
        socket?.emit('total_message_count', { user_id: other_user_id });
        socket?.emit('total_message_count', {});
        scrollToBottomChat();

                  
        
        



    }, [message, other_user_id, alert]);

    const handleSendMessageKeyPress = useCallback((e) => {
        if (e.key === 'Enter') {
            handleSendMessage();
        }
    }, [handleSendMessage]);

    const handleButtonClick = useCallback((msg) => {
        setIsMsgRead(false);
        if (socket?.connected === false) {
            socket.connected = true;
        }


        const productDetails = JSON.parse(sessionStorage.getItem('productDetails'));
           
            
            if (productDetails && !enquirySentRef.current && other_user_id == productDetails?.seller_id) {
                 console.log('productDetails other_user_id', other_user_id, 'productDetails seller_id', productDetails?.seller_id );
                //  setTimeout(() => {   
                enquirySentRef.current = true;
                const attachment = {
                    product_url: productDetails?.slug + '/' + productDetails?.id,
                    image_url: productDetails?.image
                };
                const { carat, certificate, clarity, color, shape, seller_id, stockNumber, cut, polish, symmetry, fluorescence } = productDetails;
                const message = `${shape} ${carat}ct  ${color ? color : ''} ${clarity ? clarity : ''} ${certificate ? certificate : ''} ${cut ? cut : ''} ${polish ? polish : ''} ${symmetry ? symmetry : ''} ${fluorescence ? fluorescence : ''} ${stockNumber ? stockNumber : ''}`;
                
                const enquiryData = {
                    product_id: productDetails?.id,
                    slug: productDetails?.slug,
                    other_user_id: seller_id,
                    message: message,
                    attachment_url: JSON.stringify(attachment),
                    type: 'ENQUIRY'
                };
                console.log('product details enq', enquiryData);
                
                // socket.emit('send_message', encryptData(data));
                socket.emit('send_message', enquiryData);
                // socket?.emit('total_message_count', encryptData({ user_id: other_user_id }));
                socket?.emit('total_message_count', { user_id: other_user_id });
                socket.emit('total_message_count', {});
                sessionStorage.removeItem('productDetails');
                setProductDetailsStatus(true);
                // scrollToBottomChat();
                // }, 700);
            }

        const data = {
            other_user_id: other_user_id,
            message: msg,
            type: 'TEXT'
        };

        // socket?.emit('send_message', encryptData(data));
        socket?.emit('send_message', data);
        // socket?.emit('total_message_count', encryptData({ user_id: other_user_id }));
        socket?.emit('total_message_count', { user_id: other_user_id });
        socket?.emit('total_message_count', {});
        scrollToBottomChat();
    }, [other_user_id]);

    const handleImage = useCallback(() => {
        $('.s-i-image').css('display', 'block');
    }, []);




    const handleScroll = useCallback(() => {
        if (hash) {
            const container = messageContainerRef.current;
            if (!container) return;
            if ((container.scrollTop <= 200) && (!loading) && (messageHistory?.total_record > chatData?.length) && (hash == '1')) {
                const oldScrollHeight = container.scrollHeight;
                setPage(prev => prev + 1);
                dispatch(getMessageHistoryAction(user_id, Number(other_user_id), page + 1, limit))
                    .then(() => {
                        const newScrollHeight = container.scrollHeight;
                        container.scrollTop = newScrollHeight - oldScrollHeight + 210 + container.scrollTop;
                    });
            }
        }
    }, [hash, loading, messageHistory?.total_record, limit, page, user_id, other_user_id]);


    // ============================================================================
    // MEMOIZED VALUES
    // ============================================================================

    const reversedChatData = useMemo(() => chatData?.slice(0)?.reverse(), [chatData]);
    // const isWelcome = !messageHistory;
    const isWelcome = reversedChatData?.length > 0 ? false : true;
    const isCevaheer = other_user_id === '-1';
    const loaderpage = sessionStorage?.getItem('other_user_id') && reversedChatData?.length <= 0 ? true : false

    useEffect(() => {
        const container = messageContainerRef.current;

        if (container) {
            if (loading || loaderpage) {
                container.classList.add('scroll-disabled');
            } else {
                container.classList.remove('scroll-disabled');
            }
        }
    }, [loading, loaderpage]);



    return (
        <Fragment>
            {isWelcome && !loaderpage ? (
                <Welcome />
            ) : (
                <Fragment>
                    <div className="col-md-7 col-lg-9">
                        <div className="msgdetail">
                            <h3>
                                <Avatar
                                    name={other_user_name}
                                    src={other_profile_picture_full_thumb}
                                    color="#012F5B"
                                    size="45"
                                    value="86%"
                                    round
                                />
                                <span style={{ paddingLeft: '12px' }}>
                                    {isCevaheer ? 'Cevaheer' : other_user_name}
                                </span>
                            </h3>
                            <div className="clearfix"></div>
                            {loading || loaderpage ? <ChatLoader /> : null}
                            <div
                                className="message_list"
                                ref={messageContainerRef}
                                onScroll={handleScroll}
                                id='scrollbar'
                            >

                                {reversedChatData?.map((messageData, key) => (
                                    <MessageItem
                                        key={key}
                                        messageData={messageData}
                                        user_id={user_id}
                                        handleImage={handleImage}
                                        isOwnMessage={user_id === messageData.user_id}
                                    />
                                ))}
                            </div>
                            {other_user_id !== '-1' && (
                                <div className="row mt-5 pt-4 brdr-top msgFooter">
                                    <div className="col-md-12 pl-md-0">
                                        <div className='chat-suggestion'>
                                            {Array.isArray(shortmsg) && shortmsg.length > 0 ? (
                                                shortmsg.map((msg, index) => (
                                                    <button
                                                        className="btn cs-btn"
                                                        key={index}
                                                        onClick={() => handleButtonClick(msg)}
                                                    >
                                                        {msg}
                                                    </button>
                                                ))
                                            ) : (
                                                <p></p>
                                            )}
                                        </div>
                                    </div>
                                    <div className="col-md-9 pl-md-0">
                                        <input
                                            type="text"
                                            placeholder={localStorage.getItem('lang') === 'tr' ? 'Mesaj yazın...' : 'Write a message...'}
                                            className="form-control"
                                            value={message}
                                            onChange={(e) => setMessage(e.target.value)}
                                            onKeyDown={handleSendMessageKeyPress}
                                        />
                                    </div>
                                    <div className="col-md-3 pl-md-0 pr-md-0">
                                        <button className="btn-black" onClick={handleSendMessage}>
                                            <FormattedMessage id="Send" defaultMessage="Send" />
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </Fragment>
            )}
        </Fragment>
    );
};

export default React.memo(Chatbox); 